import { Routes } from '@angular/router';

import { LoginComponent } from './pages/auth/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { RegisterComponent } from './pages/auth/register/register.component';
import { ForgotPasswordComponent } from './pages/auth/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './pages/auth/verify-email/verify-email.component';
import { AccountInactiveComponent } from './pages/auth/account-inactive/account-inactive.component';

import { authGuard } from '@core/guards/auth.guard';
import { guestGuard } from '@core/guards/guest.guard';
import { dashboardRoutes } from './pages/dashboard/dashboard.routes';

export const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [guestGuard] },
  {
    path: 'backoffice',
    component: LoginComponent,
    data: { backoffice: true },
    canActivate: [guestGuard]
  },
  { path: 'register', component: RegisterComponent },
  { path: 'verify-email', component: VerifyEmailComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'account-inactive', component: AccountInactiveComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard],
    children: dashboardRoutes
  },

  { path: 'home', redirectTo: 'dashboard/home', pathMatch: 'full' },
  { path: 'agent-settings', redirectTo: 'dashboard/agent-config', pathMatch: 'full' },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
